export default "__VITE_ASSET__ut5$Tipg__"